import { Font } from '@react-pdf/renderer';
// react-pdf/fontkit reads TTF/OTF/WOFF — NOT woff2 — so register the `.woff`
// weights (Vite resolves `?url` to a hashed, same-origin asset the renderer
// fetches at PDF time). These are the SAME faces the web document uses (Inter as
// the body, Geist Mono for the eyebrows and money figures), so the hosted
// document and its PDF share one typeface.
import inter400 from '@fontsource/inter/files/inter-latin-400-normal.woff?url';
import inter500 from '@fontsource/inter/files/inter-latin-500-normal.woff?url';
import inter600 from '@fontsource/inter/files/inter-latin-600-normal.woff?url';
import inter700 from '@fontsource/inter/files/inter-latin-700-normal.woff?url';
import inter400i from '@fontsource/inter/files/inter-latin-400-italic.woff?url';
import inter700i from '@fontsource/inter/files/inter-latin-700-italic.woff?url';
import geistMono400 from '@fontsource/geist-mono/files/geist-mono-latin-400-normal.woff?url';
import geistMono500 from '@fontsource/geist-mono/files/geist-mono-latin-500-normal.woff?url';
import geistMono600 from '@fontsource/geist-mono/files/geist-mono-latin-600-normal.woff?url';

let registered = false;

/**
 * Register the document typefaces with react-pdf once, so a document PDF can set
 * `fontFamily: 'Inter'` / `'Geist Mono'` and render the SAME faces as the hosted
 * web document (instead of the built-in Helvetica). Idempotent and safe to call
 * on every render. Registration failure is swallowed — the PDF then falls back
 * to Helvetica rather than failing to render.
 */
export function registerInterPdfFont(): void {
  if (registered) return;
  registered = true;
  try {
    Font.register({
      family: 'Inter',
      fonts: [
        { src: inter400, fontWeight: 400 },
        { src: inter500, fontWeight: 500 },
        { src: inter600, fontWeight: 600 },
        { src: inter700, fontWeight: 700 },
        { src: inter400i, fontWeight: 400, fontStyle: 'italic' },
        { src: inter700i, fontWeight: 700, fontStyle: 'italic' },
      ],
    });
    Font.register({
      family: 'Geist Mono',
      fonts: [
        { src: geistMono400, fontWeight: 400 },
        { src: geistMono500, fontWeight: 500 },
        { src: geistMono600, fontWeight: 600 },
      ],
    });
  } catch {
    // Leave the document on Helvetica if the faces can't be registered.
    registered = false;
  }
}
